import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import MobileSidebar from './MobileSidebar';

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const pageTitles = {
    '/dashboard': 'لوحة التحكم',
    '/dashboard/tests': 'الاختبارات',
    '/dashboard/results': 'النتائج',
    '/dashboard/profile': 'الملف الشخصي',
    '/dashboard/settings': 'الإعدادات'
  };

  const currentTitle = pageTitles[location.pathname] || 'لوحة التحكم';

  return (
    <div dir="rtl" className="flex h-screen bg-gray-50">
       <div className="hidden lg:flex lg:flex-shrink-0">
        <Sidebar />
      </div>

       <MobileSidebar 
        sidebarOpen={sidebarOpen} 
        setSidebarOpen={setSidebarOpen} 
      />

       <div className="flex-1 flex flex-col overflow-hidden">
        <Header 
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          title={currentTitle}
        />
        
        <main className="flex-1 overflow-y-auto">
          <div className="container mx-auto px-4 py-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;